/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M6 7L9 2M15 2L18 7"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2.53103 14.6551C2.00622 12.0311 1.74381 10.7191 2.09903 9.69225C2.4106 8.79163 3.03348 8.03184 3.8555 7.5497C4.7927 7 6.13072 7 8.80675 7H15.1933C17.8693 7 19.2073 7 20.1445 7.5497C20.9665 8.03184 21.5894 8.79163 21.901 9.69225C22.2562 10.7191 21.9938 12.0311 21.469 14.6551L21.029 16.8551C20.6624 18.6878 20.4792 19.6041 20.0007 20.2896C19.5788 20.894 18.9981 21.3701 18.3226 21.6653C17.5567 22 16.6222 22 14.7533 22H9.24675C7.37779 22 6.44332 22 5.67737 21.6653C5.00194 21.3701 4.4212 20.894 3.99929 20.2896C3.52083 19.6041 3.33756 18.6878 2.97103 16.8551L2.53103 14.6551Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M2.53103 14.6551C2.00622 12.0311 1.74381 10.7191 2.09903 9.69225C2.4106 8.79163 3.03348 8.03184 3.8555 7.5497C4.7927 7 6.13072 7 8.80675 7H15.1933C17.8693 7 19.2073 7 20.1445 7.5497C20.9665 8.03184 21.5894 8.79163 21.901 9.69225C22.2562 10.7191 21.9938 12.0311 21.469 14.6551L21.029 16.8551C20.6624 18.6878 20.4792 19.6041 20.0007 20.2896C19.5788 20.894 18.9981 21.3701 18.3226 21.6653C17.5567 22 16.6222 22 14.7533 22H9.24675C7.37779 22 6.44332 22 5.67737 21.6653C5.00194 21.3701 4.4212 20.894 3.99929 20.2896C3.52083 19.6041 3.33756 18.6878 2.97103 16.8551L2.53103 14.6551Z"
				fill="currentColor"
			/>
			<path
				d="M6 7L9 2M15 2L18 7M9.24675 22H14.7533C16.6222 22 17.5567 22 18.3226 21.6653C18.9981 21.3701 19.5788 20.894 20.0007 20.2896C20.4792 19.6041 20.6624 18.6878 21.029 16.8551L21.469 14.6551C21.9938 12.0311 22.2562 10.7191 21.901 9.69225C21.5894 8.79163 20.9665 8.03184 20.1445 7.5497C19.2073 7 17.8693 7 15.1933 7H8.80675C6.13072 7 4.7927 7 3.8555 7.5497C3.03348 8.03184 2.4106 8.79163 2.09903 9.69225C1.74381 10.7191 2.00622 12.0311 2.53103 14.6551L2.97103 16.8551C3.33756 18.6878 3.52083 19.6041 3.99929 20.2896C4.4212 20.894 5.00194 21.3701 5.67737 21.6653C6.44332 22 7.37779 22 9.24675 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.6431 2.38586C9.85621 2.03068 9.74103 1.56998 9.38585 1.35687C9.03066 1.14376 8.56997 1.25893 8.35686 1.61412L5.52768 6.32941C4.73264 6.40512 4.06281 6.55859 3.47603 6.90276C2.49988 7.4753 1.76021 8.37755 1.39022 9.44703C1.15984 10.113 1.14758 10.8262 1.23954 11.6572C1.32996 12.4742 1.53207 13.4847 1.78844 14.7666L1.79557 14.8022L2.23557 17.0022L2.24132 17.031C2.41971 17.9229 2.56171 18.633 2.72065 19.2037C2.88383 19.7897 3.07769 20.2796 3.38427 20.7188C3.8853 21.4366 4.57492 22.0019 5.377 22.3525C5.86779 22.567 6.3862 22.661 6.99282 22.7061C7.58368 22.75 8.30779 22.75 9.21747 22.75H9.24672H14.7532H14.7825C15.6922 22.75 16.4163 22.75 17.0071 22.7061C17.6138 22.661 18.1322 22.567 18.623 22.3525C19.425 22.0019 20.1146 21.4366 20.6157 20.7188C20.9223 20.2796 21.1161 19.7897 21.2793 19.2037C21.4382 18.633 21.5802 17.923 21.7586 17.031L21.7644 17.0022L22.2044 14.8022L22.2115 14.7666C22.4679 13.4847 22.67 12.4742 22.7604 11.6572C22.8524 10.8262 22.8401 10.113 22.6097 9.44703C22.2397 8.37755 21.5001 7.4753 20.5239 6.90276C19.9371 6.55859 19.2673 6.40512 18.4723 6.32941L15.6431 1.61412C15.43 1.25893 14.9693 1.14376 14.6141 1.35687C14.2589 1.56998 14.1437 2.03068 14.3569 2.38586L16.6781 6.25466C16.2373 6.24999 15.7559 6.24999 15.2296 6.24999H15.2296H15.1932H8.80672H8.77039H8.77032C8.24406 6.24999 7.76264 6.24999 7.32182 6.25466L9.6431 2.38586Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M14 7H14.5H15.1933C17.8693 7 19.2073 7 20.1445 7.5497C20.9665 8.03184 21.5894 8.79163 21.901 9.69225C22.2562 10.7191 21.9938 12.0311 21.469 14.6551L21.029 16.8551C20.6624 18.6878 20.4792 19.6041 20.0007 20.2896C19.5788 20.894 18.9981 21.3701 18.3226 21.6653C17.5567 22 16.6222 22 14.7533 22H9.24675C7.37779 22 6.44332 22 5.67737 21.6653C5.00194 21.3701 4.4212 20.894 3.99929 20.2896C3.52083 19.6041 3.33756 18.6878 2.97103 16.8551L2.53103 14.6551C2.00622 12.0311 1.74381 10.7191 2.09903 9.69225C2.4106 8.79163 3.03348 8.03184 3.8555 7.5497C4.7927 7 6.13072 7 8.80674 7H9.5H10M6 7L9 2M15 2L18 7"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M6 7L9 2M15 2L18 7M9.24675 22H14.7533C16.6222 22 17.5567 22 18.3226 21.6653C18.9981 21.3701 19.5788 20.894 20.0007 20.2896C20.4792 19.6041 20.6624 18.6878 21.029 16.8551L21.469 14.6551C21.9938 12.0311 22.2562 10.7191 21.901 9.69225C21.5894 8.79163 20.9665 8.03184 20.1445 7.5497C19.2073 7 17.8693 7 15.1933 7H8.80675C6.13072 7 4.7927 7 3.8555 7.5497C3.03348 8.03184 2.4106 8.79163 2.09903 9.69225C1.74381 10.7191 2.00622 12.0311 2.53103 14.6551L2.97103 16.8551C3.33756 18.6878 3.52083 19.6041 3.99929 20.2896C4.4212 20.894 5.00194 21.3701 5.67737 21.6653C6.44332 22 7.37779 22 9.24675 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.80672 6.25012H8.77038C7.46315 6.25012 6.43261 6.25011 5.61374 6.32168C4.78081 6.39448 4.08386 6.54638 3.47603 6.90289C2.49988 7.47543 1.76021 8.37768 1.39022 9.44717C1.15984 10.1131 1.14758 10.8263 1.23954 11.6573C1.32996 12.4743 1.53207 13.4849 1.78844 14.7667L1.79557 14.8024L2.23557 17.0024L2.24131 17.0311L2.24132 17.0311C2.41971 17.9231 2.56171 18.6331 2.72065 19.2039C2.88383 19.7899 3.07769 20.2798 3.38427 20.719C3.8853 21.4367 4.57492 22.0021 5.377 22.3526C5.86779 22.5671 6.3862 22.6611 6.99282 22.7062C7.58367 22.7501 8.30776 22.7501 9.21741 22.7501H9.24672H14.7532H14.7825C15.6922 22.7501 16.4163 22.7501 17.0071 22.7062C17.6138 22.6611 18.1322 22.5671 18.623 22.3526C19.425 22.0021 20.1146 21.4367 20.6157 20.719C20.9223 20.2798 21.1161 19.7899 21.2793 19.2039C21.4382 18.6331 21.5802 17.9231 21.7586 17.0311L21.7644 17.0024L22.2044 14.8024L22.2115 14.7667C22.4679 13.4849 22.67 12.4743 22.7604 11.6573C22.8524 10.8263 22.8401 10.1131 22.6097 9.44717C22.2397 8.37768 21.5001 7.47543 20.5239 6.90289C19.9161 6.54638 19.2191 6.39448 18.3862 6.32168C17.5673 6.25011 16.5368 6.25012 15.2296 6.25012H15.1932H8.80672Z"
				fill="currentColor"
			/>
			<path
				d="M6 7L9 2M15 2L18 7"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
